module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-table', [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("基本信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("业务编号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.businessNo))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("业务名称")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.businessName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("业务分类")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.businessClass))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("委托目的")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.entrustName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("委托时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.receiveDate))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("委托方要求完成时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.claimCompleteDate))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("合同编号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.contractNo))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("合同名称")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.contractName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("实际应收金额(元)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.baseReceivables))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("委托单位信息")]), _vm._v(" "), _c('td', [_c('x-button', {
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.getImg('showUnitPage_1')
      }
    }
  }, [_vm._v("查看")])], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("安排业务科室")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("主办人（项目负责人）")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.managerName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("主办部门")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.departmentName))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("报告信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("报告日期")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.reportDate))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("报告号")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.reportNo))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("报告分数")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.reportCount))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("清单份数")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.inventoryCount))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name detail-page-img"
  }, [_vm._v("造价文件")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('x-button', {
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.getImg('worktree')
      }
    }
  }, [_vm._v("查看")])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name detail-page-img"
  }, [_vm._v("工时汇总")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('x-button', {
    attrs: {
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.getImg('worktime')
      }
    }
  }, [_vm._v("查看")])], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a924aff","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/todo/business/cost.vue
// module id = sW7g
// module chunks = 1